<div class="container-fluid" [style.pointer-events]="mailIsSending ? 'none' : ''" [style.cursor]="mailIsSending ? 'progress' : ''">
  <div class="row">
    <div *ngIf="contacts?.length > 0 || model?.ListDocAffected?.length > 0" class="col-2">
      <span class="q-font-12">Rappel des sélections:</span>
      <fieldset *ngIf="contacts?.length > 0" class="q-fieldset mt-1" style="height: fit-content;">
        <legend><i class="fas fa-users"></i>Destinataires</legend>
        <div *ngFor="let contact of contacts">
          <span>{{contact.Value}}</span>
        </div>
      </fieldset>
      <fieldset *ngIf="model?.ListDocAffected?.length > 0" class="q-fieldset mt-1" style="height: fit-content;">
        <legend title="Document suivant affectation"><i class="fas fa-file-alt"></i>Documents</legend>
        <div *ngFor="let document of model.ListDocAffected">
          <span>{{document.Value}}</span>
        </div>
      </fieldset>
    </div>
    <div class="col">
      <div class="row">

        <div class="col-auto mt-2">
          <i class="fas fa-at m-1" [ngClass]="{'q-c-main': !Sms}"></i>
          <div class="checkbox checbox-switch switch-primary d-inline">
            <label>
              <input type="checkbox" id="sms" [(ngModel)]="Sms" [disabled]="mailIsSending" />
              <span></span>
            </label>
          </div>
          <i class="fas fa-sms" [ngClass]="{'q-c-main': Sms}"></i>
        </div>

        <div class="col-9 col-sm-8 col-md-5 col-lg-4 col-xl-3 mr-auto mt-2">
          <!--#region select model-->
          <select class="q-main-select w-100" [ngClass]="{'d-none': Sms}" [(ngModel)]="selectedModel" (change)="OnModelChange($event.target.value)" [disabled]="mailIsSending">
            <option *ngFor="let model of modeles" [value]="model.value">{{model.key}}</option>
          </select>
          <!--#endregion-->
        </div>
        <div class="col-auto pr-0 position-relative ml-md-auto ml-0 my-2" title="{{envoyerAdestinataireTooltip}}">
          <!--#region boutons d'envoi-->
          <button class="q-btn q-main mr-0" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px;"
                  (click)="SendMail(false)" [disabled]="mailIsSending">
            <ng-container *ngIf="!mailIsSending else loader">
              <i class="fas fa-paper-plane mr-2"></i>
            </ng-container>
            <ng-template #loader>
              <span class="q-c-white mr-2">
                <i class="fas fa-spinner fa-spin fa-pulse"></i>
              </span>
            </ng-template>
            <span *ngIf="!Sms">{{envoyerAdestinataire}}</span>
            <span *ngIf="Sms">Envoyer le SMS</span>
          </button>
          <button class="q-btn q-main mx-0"
                  (click)="openPopUp($event, 'popUp')"
                  style="border-top-left-radius: 0px; border-bottom-left-radius: 0px;border-left: 1px solid var(--c-dark-main);">
            <i class="fas fa-sort-down"></i>
          </button>
          <!--#region popup d'envoi programmé-->
          <div id="popUp" class="popup">
            <div class="container-fluid justify-content-center">
              <div class="row justify-content-center">
                <div class="date-size mr-2">
                  <q-date class="w-100" [(ngValue)]="date"></q-date>
                </div>
              </div>
              <div class="row justify-content-center my-1">
                <button class="q-btn q-white m-0 px-4 mt-3" (click)="SendMail(true)" [disabled]="mailIsSending">
                  <ng-container *ngIf="mailIsSending else ProgrammedSending">
                    <div style="flex: 1;"
                         class="d-flex justify-content-center align-items-center q-c-main">
                      <i class="fas fa-spinner fa-spin fa-pulse"></i>
                    </div>
                  </ng-container>
                  <ng-template #ProgrammedSending>
                    <span class="position-relative mr-2">
                      <i class="q-c-main fas fa-paper-plane"></i>
                      <i class="q-c-main far fa-clock fa-xs"
                         style="position: absolute;bottom: 3px;right: -7px;background-color:#ffffff;border-radius: 50%;"></i>
                    </span>
                  </ng-template>
                  <span>Programmer l'envoi</span>
                </button>
              </div>
            </div>

          </div>
          <!--#endregion-->
          <!--#endregion-->
        </div>
      </div>

      <div class="row mb-3" *ngIf="contacts && contacts.length > 0 && model.SelectedModel && !Sms">
        <div class="col-auto">
          <span class="q-font-12">Visualiser pour :</span>
        </div>
        <div class="col-9 col-sm-8 col-md-5 col-lg-4 col-xl-3 mr-auto" title="{{envoyerAdestinataireTooltip}}" >
          <!--#region select model-->
          <select class="q-main-select w-100" [(ngModel)]="idContactSelected" (change)="OnContactSelected($event.target.value)" [disabled]="mailIsSending || contacts.length == 1">
            <option value="0">- - - - -</option>
            <option *ngFor="let contact of contacts" [value]="contact.Ident">{{contact.Value}}</option>
          </select>
          <!--#endregion-->
        </div>
      </div>

      <!--#region inputs (expéditeur, destinataires, objet)-->
      <div class="row" *ngIf="!Sms">
        <input autocomplete="off" type="text" name="De" value="" class="col q-input-border" placeholder="De" [(ngModel)]="sender" [disabled]="mailIsSending" />
      </div>
      <div class="row" *ngIf="Sms"
           [ngbPopover]="SmsFromTemplate"
           placement="bottom-left"
           [autoClose]="'outside'"
           container="body"
           [disablePopover]="smsSender"
           #SmsFromPopover="ngbPopover">
        <input autocomplete="off" type="text" name="De" value="" class="col q-input-border" placeholder="De" [(ngModel)]="smsSender" [disabled]="mailIsSending" />

        <ng-template #SmsFromTemplate>
          <div class="popover-container">
            <ul style="margin-left:0; padding-left:0;">
              <ng-container *ngFor="let optionSmsSender of lstSmsSenders">
                <li (click)="SmsFromPopover.close(); smsSender = optionSmsSender" class="q-pointer popover-li" style="padding-left:1rem;padding-right:1rem;">
                  <span>{{optionSmsSender}}</span>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-template>
      </div>

      <div class="row">
        <button class="q-btn q-btn-users mr-1" (click)="addAllMail()" *ngIf="contacts && contacts.length > 0 " title="ajouter tous les contacts"><i class="fas fa-users"></i></button>
        <div class="a-input-container d-flex flex-wrap col q-input-border pr-0 pl-1">
          <q-inputmail-list *ngIf="!Sms" style="flex: 1;" [(list)]="listRecipientTo" [datalist]="contacts" propName="Mails" [idContact]="getIdContactPricipal()" placeholder="A" [regex]="Sms ? regexSms : regexEmail" [disabled]="mailIsSending"></q-inputmail-list>
          <q-inputmail-list *ngIf="Sms" style="flex: 1;" [(list)]="listSms" [datalist]="contacts" propName="Tels" [idContact]="getIdContactPricipal()" placeholder="A" [regex]="Sms ? regexSms : regexEmail" [disabled]="mailIsSending"></q-inputmail-list>
          <div [ngClass]="{'d-none': Cc || Sms}" (click)="Cc = true" class="cc-cci-button col-auto">Cc</div>
          <div [ngClass]="{'d-none': Cci || Sms}" (click)="Cci = true" class="cc-cci-button col-auto">Cci</div>
        </div>
      </div>

      <div class="row" [ngClass]="{'d-none': !Cc || Sms}">
        <div class="a-input-container d-flex flex-wrap col q-input-border pr-0 pl-1">
          <q-inputmail-list style="flex: 1;" [(list)]="listRecipientCc" [datalist]="contacts" propName="Mails" [idContact]="getIdContactPricipal()" placeholder="Cc" [regex]="regexEmail" [disabled]="mailIsSending"></q-inputmail-list>

          <!--<input type="text" name="Cc" value="" class="a-input" placeholder="Cc" />-->
          <div (click)="Cc = false" class="times-button q-c-dark-grey col-auto q-pointer"><i class="fas fa-times fa-xs"></i></div>
        </div>
      </div>

      <div class="row" [ngClass]="{'d-none': !Cci || Sms}">
        <div class="a-input-container d-flex flex-wrap col q-input-border pr-0 pl-1">
          <q-inputmail-list style="flex: 1;" [(list)]="listRecipientBcc" [datalist]="contacts" propName="Mails" [idContact]="getIdContactPricipal()" placeholder="Cci" [regex]="regexEmail" [disabled]="mailIsSending"></q-inputmail-list>
          <!--<input type="text" name="Cci" value="" class="a-input" placeholder="Cci" />-->
          <div (click)="Cci = false" class="times-button q-c-dark-grey col-auto q-pointer"><i class="fas fa-times fa-xs"></i></div>
        </div>
      </div>

      <div class="row" [ngClass]="{'d-none': Sms}">
        <input autocomplete="off" type="text" name="Objet" [(ngModel)]="Object" class="col q-input-border" placeholder="Objet" [disabled]="mailIsSending" />
      </div>
      <!--#endregion-->
      <div class="row mb-2" [ngClass]="{'d-none': Sms}">
        <!--#region pièces jointes-->
        <div class="col doc-container mr-2">

          <ng-container *ngFor="let file of files; let i = index">
            <button class="m-1 rounded-button d-inline deletable q-dark-secondary" (click)="ToggleFile($event, file)">
              {{file.fileName}}
              <span *ngIf="!attachmentToPdf || (attachmentToPdf && file.extension !== '.doc' && file.extension !== '.docx')" class="mr-1">{{file.extension}}</span>
              <span *ngIf="attachmentToPdf && (file.extension === '.doc' || file.extension === '.docx')" class="mr-1">.pdf</span>
            </button>
          </ng-container>
        </div>

        <div class="col-auto ml-auto mr-2 p-0 position-relative">
          <i class="far fa-file-word m-1" [ngClass]="{'q-c-success': !attachmentToPdf}" title="Envoyer les fichiers au format original"></i>
          <div class="checkbox checbox-switch switch-primary d-inline" title="Mode d'envoi des piéces jointes">
            <label>
              <input type="checkbox" id="checkAttachmentToPdf" [(ngModel)]="attachmentToPdf" />
              <span></span>
            </label>
          </div>
          <i class="far fa-file-pdf" [ngClass]="{'q-c-danger': attachmentToPdf}" title="Envoyer les fichiers Word au format .pdf (convertion doc et docx en pdf)"></i>
        </div>



        <div class="col-auto p-0 position-relative">
          <button class="q-btn q-main mr-0" (click)="openPopUp($event, 'paperclipPopUp')"><i class="fas fa-paperclip"></i></button>

          <div id="paperclipPopUp" class="paperclipPopUp">
            <div class="container-fluid justify-content-center">
              <div class="row justify-content-center">
                <!--Titre en fonction du type-->
                <p class="col q-bold q-text-m" *ngIf="type === 'STAGE'">Documents du stage</p>
                <p class="col q-bold q-text-m" *ngIf="type === 'ACTIONCO'">Action commerciale</p>
              </div>
              <div class="container-fluid w-100" style="list-style: none;">
                <!--DOCUMENTS LIES AU PERE-->
                <!--Si pas de groupes : tous les documents-->
                <div *ngIf="listGroupDoc.length === 0">
                  <ng-container *ngFor="let doc of listDocuments">
                    <ng-container *ngTemplateOutlet="doc.isWebLink ? webDocument : fileDocument; context: { doc: doc }">
                    </ng-container>
                  </ng-container>
                </div>
                <!--Si groupes : tri par groupes-->
                <div *ngIf="listGroupDoc.length > 0">
                  <div *ngFor="let group of listGroupDoc">
                    <p class="col q-bold q-text-m">{{group}}</p>
                    <ng-container *ngFor="let doc of listDocuments">
                      <div *ngIf="doc.group === group">
                        <ng-container *ngTemplateOutlet="doc.isWebLink ? webDocument : fileDocument; context: { doc: doc }">
                        </ng-container>
                      </div>

                    </ng-container>
                    <hr />
                  </div>

                </div>
              </div>
              <hr />
              <div class="row justify-content-center my-1">
                <p class="col q-bold q-text-m">Fichier local</p>
              </div>
              <div class="row justify-content-center my-1">
                <div class="d-flex col">

                  <button class="q-btn q-secondary" (click)="localFileInput.value = null; localFile = null; localFileInput.click();">Choisir un fichier</button>
                  <ng-container *ngIf="!localFileIsBeingExported else localFileLoader">
                    <ng-container *ngIf="localFile">
                      <div style="flex: 1;display: flex;">
                        <span class="q-c-main mr-1" style="align-self: center;">nom</span>
                        <input type="text" class="h-100 q-input-border" [(ngModel)]="localFileName" style="flex: 1;border-top-right-radius: 0px;border-bottom-right-radius: 0px;" />
                      </div>
                      <button class="q-btn q-success local-file-btn" (click)="OnFileSave($event)">
                        <i class="fas fa-upload fa-xs"></i>
                      </button>
                    </ng-container>
                  </ng-container>
                  <ng-template #localFileLoader>
                    <div class="d-flex">
                      <div style="flex: 1;"
                           class="d-flex justify-content-center align-items-center q-c-main">
                        <i class="fas fa-spinner fa-spin fa-pulse"></i>
                      </div>
                    </div>
                  </ng-template>
                  <input #localFileInput type="file" id="localFile"
                         class="d-none"
                         accept="{{accept}}"
                         (change)="onSelectLocalFileChange($event)" />
                </div>
              </div>
              <div class="container-fluid w-100" style="list-style: none;">
                <ng-container *ngFor="let local of localDocument">
                  <ng-container *ngTemplateOutlet="local.isWebLink ? webDocument : fileDocument; context: { doc: local }">
                  </ng-container>
                </ng-container>
              </div>
              <hr />
              <ul class="w-100 p-0 m-0">
                <div class="accordion chevron row justify-content-center my-1" (click)="AccordionClicked($event.currentTarget)">
                  <p class="col q-bold q-text-m m-0">GED</p>
                </div>

                <ul class="panel">
                  <q-gestion-electronique-documents (fileClicked)="ToggleFile(null, $event)"></q-gestion-electronique-documents>
                </ul>
              </ul>

              <hr />
              <ng-container *ngIf="customerDocuments && customerDocuments.length > 0">
                <div class="accordion chevron row justify-content-center my-1" (click)="AccordionClicked($event.currentTarget)">
                  <p class="col q-bold q-text-m m-0">Client</p>
                </div>
                <div class="panel container-fluid w-100">
                  <ng-container *ngFor="let customer of customerDocuments">
                    <ng-container *ngTemplateOutlet="customer.isWebLink ? webDocument : fileDocument; context: { doc: customer }">
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <!--#endregion-->
      </div>
      <div class="row">

        <!--<ng-container *ngIf="!Sms && selectedModel && ckeditorVersion === '4'">
          <button *ngIf="!forceEdit" (click)="forceEdit = !forceEdit;" class="q-btn q-main col-auto">Éditer</button>
          <button *ngIf="forceEdit" (click)="forceEdit = !forceEdit;" class="q-btn q-main col-auto mb-2">Visualiser</button>
        </ng-container>
        <ng-container *ngIf="!Sms && selectedModel && ckeditorVersion === '4' && !forceEdit; else ckediteur">
          <div class="w-100" [innerHTML]="contentMail"></div>
        </ng-container>
        <ng-template #ckediteur>-->
        <!--#region ckeditor-->

        <ng-container>
          <div *ngIf="ckDisabled && selectedModel && !Sms" class="cdEditor-disabled-msg">
            <p><i class="fa-solid fa-triangle-exclamation"></i> Vous êtes en mode prévisualisation, pas de modification possible pour l’envoi groupé. Sélectionner un contact pour modifier le contenu qui lui sera envoyé (modification unitaire)</p>
          </div>
          <ckeditor *ngIf="!Sms" class="w-100"
                    [disabled]="ckDisabled"
                    [editor]="Editor"
                    [config]="{ toolbar: {
                  items: ['undo','redo','|','outdent','indent','|','findAndReplace','sourceEditing','|','bold','italic','underline','strikethrough','removeFormat','pageBreak','|','fontColor','fontBackgroundColor','fontFamily','fontSize',
                  'alignment','highlight','|','link','imageInsert','mediaEmbed','htmlEmbed','|','bulletedList','numberedList','todoList','insertTable','|','heading','blockQuote','horizontalLine','|','code','codeBlock','|','specialCharacters',
                  'subscript','superscript', 'exportPdf', 'exportWord'],
                  shouldNotGroupWhenFull: true
                  },
                  language: 'fr',
                  image: {toolbar: [ 'imageStyle:full', 'imageStyle:side', '|', 'imageTextAlternative' ]},
                  fontSize: {options: ['default', 8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 36, 48, 50]},
                  link: { addTargetToExternalLinks: true },
                  table: { contentToolbar: [ 'tableRow', 'tableColumn', 'mergeTableCells', 'tableCellProperties', 'tableProperties' ] },
                  removePlugins: ['Title']
                  }"
                    [(ngModel)]="contentMail"
                    skin="moono-lisa" lang="fr" fullPage="true" ngDefaultControl></ckeditor>

          <div *ngIf="Sms" class="counter px-2 q-c-main">{{160 - contentSms.length}}</div>
          <textarea *ngIf="Sms" class="q-input-border w-100 mail-content-area" [(ngModel)]="contentSms" maxlength="160"></textarea>
        </ng-container>

        <!--</ng-template>-->
        <!--#endregion-->
      </div>

    </div>


  </div>
</div>

<ng-template #fileDocument let-doc="doc">
  <div class="row my-1 q-text-m w-100">
    <div class="col q-check p-0 ml-2">
      <input type="checkbox" id="aaa" [(ngModel)]="doc.selected" />
      <label style="white-space: nowrap;" class="align-items-center w-100" (click)="ToggleFile($event, doc)" title="{{doc.infoTooltip}}">
        <span style="height: 15px; width: 15px;"></span><i class="far fa-file-alt mx-1"></i> {{doc.key}} {{doc.type}}
      </label>
    </div>
  </div>
</ng-template>
<ng-template #webDocument let-doc="doc">
  <div class="row my-1 q-text-m w-100">
    <div class="col p-0 ml-2">
      <button title="copier le lien" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;text-align: left;" class="q-btn q-white w-100" (click)="CopyToClipBoard(doc.value)">
        <i class="fas fa-link mx-1"></i> {{doc.key}}
      </button>
    </div>
  </div>
</ng-template>


